<script setup lang="ts">

import {computed, inject, ref} from 'vue';
import {LegacyOrder, legacyOrderKey} from '@hantera/portal-app';

import Delivery from './Delivery.vue'

const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));

const deliveries = computed(() => {
  return order.value.deliveries.sort((a, b) => {
    if (a.createdUtc === b.createdUtc) {
      if (a.deliveryNumber > b.deliveryNumber) {
        return -1;
      }
      if (a.deliveryNumber < b.deliveryNumber) {
        return 1;
      }
      return 0;
    }
    
    return b.createdUtc.getTime() - a.createdUtc.getTime()
  });
});

</script>

<template>
  <div class="legacy-order-view-deliveries">
    <Delivery
      v-for="delivery in deliveries"
      :key="delivery.deliveryId"
      :data="delivery"
      class="legacy-order-view-deliveries__delivery"
    />
  </div>
</template>

<style>
.legacy-order-view-deliveries {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 5px;
}
</style>